import { register, defineRelation, Direction } from 'olympe';
import InspectionEntity from './InspectionEntity.js';
import Evaluation from "./Evaluation";

/**
 * @extends {InspectionEntity}
 */
export default class Inspection extends InspectionEntity { /* empty */ }

// Hardcoded tags
register('01880fd44b495fd197fb', Inspection);
Inspection.evaluationsListRel = defineRelation('01880fd534cbc9e5e5ff', Inspection, Evaluation);
Inspection.inverse_componentinspectionsRel = defineRelation('01880fdb9f9192dd0b02', Direction.ORIGIN);
